export default __webpack_public_path__ + "static/media/Invest.187c41b1.png";